import { render, staticRenderFns } from "./DescriptionMaisonette.vue?vue&type=template&id=5834e7e4"
import script from "./DescriptionMaisonette.vue?vue&type=script&lang=js"
export * from "./DescriptionMaisonette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports